module.exports = __webpack_public_path__ + "assets/arrow.b45fa7ca.svg";